import { useLayoutEffect, useRef, useState } from "react";

export function usePageHeight() {
	const pageRef = useRef<HTMLDivElement>(null);
	const [pageHeight, setPageHeight] = useState<string | null>(null);

	useLayoutEffect(() => {
		const pageElement = pageRef.current;
		if (!pageElement) return;
		const update = () => {
			const top = pageElement.getBoundingClientRect().top;
			setPageHeight(`calc(100dvh - ${Math.max(0, top)}px)`);
		};
		update();
		window.addEventListener("resize", update);
		const mainContent = document.getElementById("main-body-content");
		const observer = new ResizeObserver(update);
		if (mainContent) observer.observe(mainContent);
		return () => {
			window.removeEventListener("resize", update);
			observer.disconnect();
		};
	}, []);

	return { pageRef, pageHeight };
}
